import React, { useState, useCallback } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { PERMISSIONS } from '../../auth/constants'

import { usePermissions, useLogout } from '../../auth/hooks'
import { useUser } from '../../user/hooks'

import styles from './SiteSwitcher.module.css'

const SiteButton = ({ name, url, icon, permissions = [], close }) => {
  const location = useLocation()
  const history = useHistory()
  const allowed = usePermissions(permissions)
  const logout = useLogout()

  const active =
    location.pathname &&
    location.pathname.toLowerCase().startsWith(url.toLowerCase())

  if (active && !allowed.every((a) => a)) logout() // if you're somewhere you shouldn't be.. logout =D

  if (!allowed.every((a) => a)) return null

  return (
    <button
      onClick={() => {
        active && close()
        history.push(url)
      }}
      className={
        active ? `${styles.active} ${styles.siteLink}` : styles.siteLink
      }
    >
      <i className={`fa ${icon} fa-fw`}></i> {name}
    </button>
  )
}

const getCurrentSiteName = (location) => {
  const path = location.pathname && location.pathname.toLowerCase()
  if (!path) return 'Unknown'
  if (path.startsWith('/commandcentral')) return 'Command Central'
  if (path.startsWith('/admin')) return 'Admin'
  if (path.startsWith('/hcfr')) return 'HCFR Active Incidents'
  if (path.startsWith('/roadclosures')) return 'Road Closures'
  if (path.startsWith('/sitrep')) return 'Situation Report'
  if (path.startsWith('/sigevents')) return 'Significant Events'
  if (path.startsWith('/poweroutages')) return 'Power Outages'
  if (path.startsWith('/palmetto')) return 'Palmetto Incidents'
  return 'Unknown'
}

const SiteSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false)
  const logout = useLogout()
  const user = useUser()
  const currentSitename = getCurrentSiteName(useLocation())

  const close = useCallback(() => setIsOpen(false), [setIsOpen])

  return (
    <>
      <div className={styles.toggleButton} onClick={() => setIsOpen((x) => !x)}>
        <small>
          <i className="fa fa-chevron-down"></i>
        </small>{' '}
        iRISS <small>{currentSitename}</small>
      </div>
      {isOpen && (
        <div className={styles.menu}>
          <div className={styles.menuTitle}>{user.name}</div>
          <SiteButton
            name="Command Central"
            icon="fa-bullhorn"
            url="/commandCentral"
            permissions={[PERMISSIONS.IRISS_ACCESS]}
            close={close}
          />
          <SiteButton
            name="HCFR Active Incidents"
            icon="fa-fire"
            url="/hcfr"
            permissions={[PERMISSIONS.HCFR_ACTIVE_INCIDENTS_VIEW]}
            close={close}
          />
          <SiteButton
            name="Palmetto Incidents"
            icon="fa-tree"
            url="/palmetto"
            permissions={[PERMISSIONS.PALMETTO_VIEW]}
            close={close}
          />
          <SiteButton
            name="Significant Events"
            icon="fa-exclamation-circle"
            url="/sigEvents"
            permissions={[PERMISSIONS.SIGNIFICANT_EVENTS_VIEW]}
            close={close}
          />
          <SiteButton
            name="Road Closures"
            icon="fa-exclamation-triangle"
            url="/roadClosures"
            permissions={[PERMISSIONS.ROAD_CLOSURES_VIEW]}
            close={close}
          />
          <SiteButton
            name="Situation Report"
            icon="fa-file"
            url="/sitrep"
            permissions={[PERMISSIONS.SITREP_VIEW]}
            close={close}
          />
          {/* <SiteButton
            name="Power Outages"
            icon="fa-battery-empty"
            url="/powerOutages"
            permissions={[PERMISSIONS.POWER_OUTAGES_VIEW]}
          /> */}
          <SiteButton
            name="Admin"
            icon="fa-wrench"
            url="/admin"
            permissions={[PERMISSIONS.ADMIN]}
            close={close}
          />
          <button
            className={`${styles.siteLink} ${styles.signout}`}
            onClick={logout}
          >
            <i className="fas fa-sign-out-alt"></i>
          </button>
        </div>
      )}
    </>
  )
}

export default SiteSwitcher
